export const finanzcoachingVsFinanzberatungFAQData = [
  {
    question: "Was ist der Hauptunterschied zwischen Finanzcoaching und Finanzberatung?",
    answer: "Finanzberatung ist produktorientiert und sucht die beste Lösung für Ihr Geld. Finanzcoaching ist personenzentriert und stärkt Ihre Selbstkompetenz, damit Sie eigenständige Entscheidungen treffen können – auch gegenüber Bankberatern oder Vermittlern."
  },
  {
    question: "Ersetzt Finanzcoaching die Anlageberatung?",
    answer: "Nein. Das Coaching bereitet Sie darauf vor, die Empfehlungen von Beratern nach § 34f/h/k kritisch zu prüfen. Es findet keine Vermittlung von Produkten oder eine rechtssichere Anlageberatung zu konkreten Instrumenten statt."
  },
  {
    question: "Für wen ist eine Finanzplanung im Einzelcoaching sinnvoll?",
    answer: "Besonders für Menschen in Umbruchphasen, bei Unsicherheit im Umgang mit Vermögen oder wenn emotionale Barrieren kluge Entscheidungen verhindern. Es ist Hilfe zur Selbsthilfe, um die Kontrolle zurückzugewinnen."
  },
  {
    question: "Was kostet ein seriöses Finanzcoaching?",
    answer: "Seriöses Coaching wird nach Zeitaufwand (Honorar) abgerechnet, nicht nach vermittelten Produkten. Dies garantiert absolute Neutralität. Die Investition zahlt sich meist durch das Vermeiden teurer Fehlkäufe oder renditeschädlicher Panikreaktionen schnell aus."
  }
];
